import React, { useState, useEffect } from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { Form, Container, Row, Col, Card, ListGroup, FloatingLabel, Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import Loading from '../../components/Loading/Loading';
import FacturaImage from '../../assets/images/contact-us.jpg'; 
import "../Contact/contact.css";
import ProgressBarLoader from "../../components/ProgressBarLoader/ProgressBarLoader";

const Factura = () => {
    const [loading, setLoading] = useState(false);
    const [invoice, setInvoice] = useState('');
    const [contactData, setContactData] = useState(null);
    const [pageLoading, setPageLoading] = useState(true);
    const [showTutorial, setShowTutorial] = useState(false);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    
    useEffect(() => {
        window.scrollTo(0, 0);
        fetchContactData();
    }, []);

    const fetchContactData = async () => {
        try {
            const response = await axios.get(`${ENDPOINT}get-page-contact/1`);
            if (response.data && response.data.res === true) {
                setContactData(response.data.data);
            }
        } catch (error) {
            console.error('Error al cargar los datos de contacto:', error);
            // Mantener los valores por defecto en caso de error
        } finally {
            setPageLoading(false);
        }
    };
    
    const handlePrint = async (e) => {
        e.preventDefault();
        setLoading(true);
        const user_id = 1;
        const form = new FormData();
        form.append("invoice", invoice);
        form.append("user_id", user_id);

        try {
            const response = await axios.post(ENDPOINT + 'print-pdf-ticket-invoice', form, { responseType: "blob" });
            const url = window.URL.createObjectURL(response.data);
            window.open(url, '_blank');
            setInvoice('');
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se encontró la factura. Verifique el folio.',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loading />}
            <ProgressBarLoader />
            <Breadcrumbs title="Factura" pagename="Factura" />
            <section className="contact pt-1">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="main_heading text-center">
                                <h1 className="text-uppercase">FACTURAS SALINACRUCENSES</h1>
                                <h6 className="h6 text-uppercase mt-3">GENERA TUS FACTURAS CON ESTOS SENCILLOS PASOS</h6>
                            </div>
                        </Col>
                    </Row>

                    {/* Cards vacías con mismo diseño */}
                    <Row className="py-4">
                        <Col lg="6" md="6" className="mb-4 mb-lg-0">
                            <Card className="border shadow rounded-3 mb-4 card-equal-height">
                                <Card.Body className="text-center">
                                    <div className="d-flex justify-content-center align-item-search my-2">
                                        <div className="bg-info rounded-circle text-info shadow-sm bg-opacity-10 p-2">
                                            <i className="bi bi-receipt h3"></i>
                                        </div>
                                    </div>
                                    <p className="mb-3 body-text" style={{ whiteSpace: 'pre-line' }}>
                                        {contactData?.card_1}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg="6" md="6" className="mb-4 mb-lg-0">
                            <Card className="border shadow rounded-3 mb-4 card-equal-height">
                                <Card.Body className="text-center">
                                    <div className="d-flex justify-content-center align-item-search my-2">
                                        <div className="bg-danger rounded-circle text-danger shadow-sm bg-opacity-10 p-2">
                                            <i className="bi bi-exclamation-circle h3"></i>
                                        </div>
                                    </div>
                                    <p className="mb-3 body-text" style={{ whiteSpace: 'pre-line' }}>
                                        {contactData?.card_2}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="pb-4 position-relative" style={{ zIndex: 2 }}>
                        <Col md="12" className="text-center">
                            <Button
                                variant="primary"
                                size="lg"
                                className="px-4 shadow"
                                onClick={() => setShowTutorial(true)}
                            >
                                <i className="bi bi-play-circle me-2"></i>
                                Ver tutorial
                            </Button>
                        </Col>
                    </Row>

                    <Modal
                        show={showTutorial}
                        onHide={() => setShowTutorial(false)}
                        centered
                        size="lg"
                        aria-labelledby="tutorial-modal-title"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="tutorial-modal-title">Tutorial de facturación</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-2 p-md-3">
                            <div className="ratio ratio-16x9 rounded overflow-hidden">
                                <iframe
                                    src="https://www.youtube.com/embed/_4PhfAAJOS0?si=jUu9IOCTFvn_xFFa"
                                    title="Tutorial de facturación"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                    style={{ border: 0 }}
                                ></iframe>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <section
                        className="iframe-section mt-4"
                        style={{
                            overflow: 'visible',
                            position: 'relative',
                            zIndex: 1,
                            height: 'calc(100vh - 120px)',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <iframe
                            src={contactData?.link_fact}
                            width="100%"
                            height="100%"
                            style={{
                                border: "none",
                                overflow: 'visible',
                                display: 'block',
                                margin: '0 auto',
                                maxWidth: '1280px',
                            }}
                            loading="lazy"
                            title="Auto Facturación"
                            scrolling="yes"
                            allow="fullscreen"
                        ></iframe>
                    </section>
                </Container>
            </section>
        </>
    );
};

export default Factura;